import React, { FormEvent } from "react";
import theme from "@monorepo/styles/theme";
import Box from "@mui/material/Box/Box";
import { styled, SxProps } from "@mui/material/styles";

const SForm = styled("form")(() => ({
  display: "grid",
  rowGap: theme.spacing(3),
  justifyItems: "center",
  overflowY: "auto",
  overflowX: "hidden",
  height: "100%",
}));

const SColumn = styled(Box)(() => ({
  display: "grid",
  alignContent: "flex-start",
  rowGap: theme.spacing(3),
  [theme.breakpoints.up("md")]: {
    width: 320,
  },
  [theme.breakpoints.up("xxl")]: {
    width: 340,
  },
}));

const SBox = styled(Box)(() => ({
  display: "flex",
  justifyItems: "space-between",
  alignItems: "flex-end",
}));

const SContent = styled(Box, { shouldForwardProp: (prop) => prop !== "sx" })(() => ({
  boxSizing: "content-box",
  width: "100%",
  height: "100%",
  justifyContent: "center",
  display: "grid",
  rowGap: theme.spacing(3),
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr) )",
  columnGap: theme.spacing(6),
  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 320px) )",
  },
  [theme.breakpoints.up("xxl")]: {
    gridTemplateColumns: "repeat(auto-fit, minmax(340px, 340px) )",
  },
}));

type TFormProps = {
  onSubmit: (() => void) | ((e: FormEvent) => void);
  children: React.ReactNode;
  sx?: SxProps;
};

export const StyledForm = (props: TFormProps) => {
  const { onSubmit, children, sx } = props;
  return (
    <SForm onSubmit={onSubmit} sx={sx}>
      {children}
    </SForm>
  );
};
export const StyledContent = (props: { children: React.ReactNode; sx?: SxProps }) => {
  const { children, sx } = props;
  return <SContent sx={sx}>{children}</SContent>;
};
export const StyledColumn = (props: { children: React.ReactNode; sx?: SxProps }) => {
  const { children, sx } = props;
  return <SColumn sx={sx}>{children}</SColumn>;
};
export const StyledBox = (props: { children: React.ReactNode }) => {
  const { children } = props;
  return <SBox>{children}</SBox>;
};
